/*
 * @Description: 公用配置项
 * @Author: shenah
 * @Date: 2023-08-10 15:02:19
 * @LastEditors: zhanghang
 * @LastEditTime: 2024-06-26 18:20:20
 */
// 字体列表选择
export const fontList = [
  {
    text: "微软雅黑",
    value: "Microsoft Yahei",
  },
  {
    "text": "时尚中黑简体",
    "value": "ShiShangZhongHeiJianTi"
  },
  {
    "text": "阿里巴巴普惠-常规",
    "value": "Alibaba-PuHuiTi-Regular"
  },
  {
    "text": "阿里巴巴普惠-中粗",
    "value": "Alibaba-PuHuiTi-Medium"
  },
  {
    "text": "阿里巴巴普惠-粗",
    "value": "Alibaba-PuHuiTi-Bold"
  },{
    "text": "思源常规",
    "value": "SourceHanSansCN-Regular"
  },
  {
    "text": "思源中粗",
    "value": "SourceHanSansCN-Medium"
  },
  {
    "text": "思源粗体",
    "value": "SourceHanSansCN-Bold"
  },
  {
    "text": "优设",
    "value": "youshe"
  },
  {
    text: "液晶数字",
    value: "DIGIT",
  },
];

// 值的转化列表
export const unitValueMap = {
  10: "十",
  100: "百",
  1000: "千",
  10000: "万",
  100000: "十万",
  1000000: "百万",
  10000000: "千万",
  100000000: "亿",
};

// 字相关的样式
export const createCommonTextStyle = (options) => {
  return dsf.mix(
    {
      // 采用单色,渐变等
      color: "#fff",
      fontWeight: "normal", // 是否加粗
      fontStyle: "normal", // 是否斜体
      textDecoration: "none", // 是否下划线
      fontFamily: "Microsoft Yahei", // 字体
      fontSize: "20", // 字号
    },
    options
  );
};
// 边框默认样式
export const createCommonBorderConfig = (options, color = "#DCDFE6") => {
  return dsf.mix(
    {
      commonBorderColor: color,
      commonBorderStyle: "solid",
      commonBorderWidth: 1,
      border: `1px solid ${color}`,
    },
    options
  );
};

// 颜色对象处理
export const handleColor = (value) => {
  if (value && typeof value === "object") {
    let { color, linear, radial } = value;
    let type = color?.type || value.active;
    switch (type) {
      case "linear":
        let angle = parseFloat(linear.angle);
        let linearStr = linear.point.map((it) => `${it.color} ${it.length}%`).join();
        return `linear-gradient(${isFinite(angle) ? angle : 90}deg, ${linearStr})`;
      case "radial":
        let radialStr = radial.point.map((it) => `${it.color} ${it.length}%`).join();
        return `linear-gradient(90deg, ${radialStr})`;
      case "color":
      default:
        return color?.value || "#fff";
    }
  } else {
    return value || "inherit";
  }
};
